module.exports = __webpack_public_path__ + "img/01.20cfa298.jpg";